module.exports = __webpack_public_path__ + "img/cat_eyes.5efdf6e2.jpg";